import { Guid, InvoiceStatuses, IsoDateString, TimeZoneId } from '@breezy/shared'
import React from 'react'
import { SimpleLoanRecord } from './LoanRecordSubscription.anon-gql'

export type SelfServePaymentFormContextInvoice = {
  invoiceGuid: Guid
  displayId: string
  companyGuid: Guid
  accountGuid: Guid
  totalPriceUsd: number
  referenceNumber: string
  status: InvoiceStatuses
  paymentsSummary: {
    amountDueUsd: number
    totalPaidAmountUsd: number
    paymentTypesDescription?: string
    lastPaidAt?: IsoDateString
  }
  links: {
    jobGuid?: Guid
    maintenancePlanGuid?: Guid
  }
}

type SelfServePaymentFormContextType = {
  invoiceGuid: Guid
  invoice: SelfServePaymentFormContextInvoice
  companyGuid: string
  companyName: string
  wisetackEnabled: boolean
  paymentCompleted: boolean
  loanApplicationStarted: boolean
  loanPaymentSucceeded: boolean
  didPaymentSucceed: boolean
  contactGuid?: string
  loanRecord?: SimpleLoanRecord
  tilledMerchantId: string
  setPaymentSuccessStatus: (didPaymentSucceed: boolean) => void
  tzId: TimeZoneId
  refetchInvoice: () => void
}

export const SelfServePaymentFormContext = React.createContext<SelfServePaymentFormContextType | undefined>(undefined)
